import React from 'react';


export default class Cadencia extends React.Component{
  constructor(props) {
    super(props);

    this.state = {

    };

  }

  render(){
    const strings = this.state.strings;
    const video = '292714621';
    return(
      <div>
        <div>Neste vídeo você vai aprender como aplicar a cadência em cada treino, uma variável essencial para a mudança de estímulo semanal do seu treino. Exemplos no final do vídeo.</div>
          <iframe
            className='vimeo-video'
            src={`https://player.vimeo.com/video/${video}?autoplay=1&loop=1&autopause=0`}
            height="300"
            frameBorder="0"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allowFullScreen="true">
          </iframe>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/tecnicas/Cadencia.js